import ContactUs from "pages/Restaurant/ContactUs";

export default function ContactUsPage() {
  return <ContactUs />;
}
